/** Relationships a customer can select as the person paying the balance back. */
export const ALLOWED_PAYBACK_METHODS: string[] = [
  'Family',
  'Spouse',
  'Guardian',
  'Siblings',
  'Acquaintance',
  'Social Security Benefits',
  'Crowdfunding/Fundraising',
  'Others'
];

/** Background colors used for customer avatars. */
export const AVATAR_COLORS: string[] = [
  '#ff5833b9', // red-orange
  '#36a3ebb9', // blue
  '#4bc0c0cb', // teal
  '#9966ffc4', // purple
  '#ffa040d0', // orange
  '#e91e62d0', // pink
  '#009687de', // green
  '#607d8bd0', // gray-blue
];

/** Icons shown in the patient verification step. */
export const PATIENT_VERIFICATION_IMAGE_LIST: string[] = Array.from(
  { length: 8 },
  (_, i) => `assets\img\svg\patient-verification\icon_${i + 1}.svg`
);

/** Proposal duration options (value is in months, except "15" which is days). */
export const PROPOSAL_DURATIONS: any[] = [
        {
            'label': '15 Days',
            'value': '15'
        },
        {
            'label': '1 Month',
            'value': '1'
        },
        {
            'label': '3 Months',
            'value': '3'
        },
        {
            'label': '6 Months',
            'value': '6'
        },
        {
            'label': '12 Months',
            'value': '12'
        },
        {
            'label': 'Custom Date',
            'value': 'Custom Date'
        }
    ];

/** Tone options for debt proposals. */
export const PROPOSAL_TONE_TYPES: any[] = [
    { name: 'Warm and approachable', value: 1 }, // polite
    { name: 'Polite and straightforward', value: 2 }, // medium
    { name: 'Direct and authoritative', value: 3 } // aggressive
  ];

/** Salutation choices for customer forms. */
export const SALUTATION_OPTIONS: any[] = [
    {
      label: 'None',
      value: 'None'
    },
    {
      label: 'Dr.',
      value: 'Dr.'
    },
    {
      label: 'Mr.',
      value: 'Mr.'
    },
    {
      label: 'Ms.',
      value: 'Ms.'
    },
    {
      label: 'Mrs.',
      value: 'Mrs.'
    },
    {
      label: 'Miss.',
      value: 'Miss.'
    }
  ];

/** Date range filters shared by the report views. */
export const REPORT_DATE_RANGE_TABS: any[] = [
    { value: '0', viewValue: 'Last week' },
    { value: '1', viewValue: 'Last 2 weeks' },
    { value: '2', viewValue: 'Last month' },
    { value: '3', viewValue: 'Last 3 months' },
    { value: '4', viewValue: 'Custom range' },
  ];

/** Currency symbol shown next to amounts (US-only business). */
export const CURRENCY_SIGN = '$';

/** Earliest selectable date of birth. */
export const MIN_BIRTH_DATE = new Date(1900, 0, 1);

/** Latest selectable date of birth: the end of today. */
export const endOfToday = (): Date => new Date(new Date().setHours(23, 59, 59));

/** Reasons offered when cancelling a proposal. */
export const PROPOSAL_CANCEL_REASONS: string[] = [
  ' The customer opted for a different platform', // leading space kept: value is sent as-is
  'The customer changed their mind',
  'A revised proposal has been sent',
  'Services have been modified',
  'This is a test proposal',
  'Other'
];

/** API names used to cancel or restore a subscription. */
export const SUBSCRIPTION_CHANGE_APIS = {
  cancel_subscription: 'cancel_subscription',
  restore_subscription: 'restore_subscription'
};
